export default __webpack_public_path__ + "static/Graphik-MediumItalic-Web-273af655160ce86e9aa8e9491c2c9bc5.eot";